<template>
  <div>

<button class="kakao-share" @click="kakaoShare">카카오공유</button>&nbsp;
<input type="text" id="text" value="https://colabear92.github.io/" style="display: none;"/>
<button class="main-button" @click="urlCopy">🔗링크 복사</button>

  </div>
</template>

<script>
export default {
    name: 'MainComponent',
    props:{
    page:Number,
  },  methods:{
    kakaoShare() {
      window.Kakao.Share.sendCustom({
        templateId: 93356 ,
        // 카카오톡이 설치 되지 않았을때 마켓으로 이동
        installTalk: true
      });},
      urlCopy(){
        var url = document.getElementById('text');
        url.style.display='block';    // 숨겨둔 input 태그 block처리
        url.select();    // 복사할 text 블럭
        document.execCommand('copy');    // 드레그된 text 클립보드에 복사
        url.style.display='none';    // 다시 숨기기
        alert('url이 복사 되었습니다.')
      }
}
    
}
</script>

<style>
.main-button{
    padding:15px;
    font-size:20px;
    background: #eee;
    border:none;
    border-radius: 10px;
    cursor: pointer;
    margin-bottom: 10px;
    text-decoration: none;
    color: black;
    /* position:absolute; */
    /* bottom:20px;
    right: 20px; */
}

.main-button:hover{
  background:rgb(187, 187, 187);
}
.kakao-share {
  padding:15px;
  font-size:20px;
  border:none;
  border-radius: 10px;
  cursor: pointer;
  color: black;
  text-align: center;
  background: #ffe944;

}
.kakao-share:hover{
  background: rgb(224, 230, 146);

}
</style>